
export class Badge {
    static readonly BADGES:{ [badgeCode: string]: Badge; } = {
        "SCRV_BETA": new Badge(
             "SCRV_BETA",
             "../../../assets/badges/beta_tester_badge.png"
        ),
        
    };
    badgeCode: string;
    imgUrl: string;


    constructor(badgeCode: string, imgUrl: string) {
        this.badgeCode = badgeCode;
        this.imgUrl = imgUrl;

    }
}